<style>
	.ly-bill-page {
			text-align: right;
			margin-top: 20px;
	}
    .el-table {
        margin-top: 20px;
    }
    .finger {
	    cursor: pointer;
	}
	/* 字体颜色 */
	.fcred {
	    color: red;
	}
	.fcorg {
	    color: orange;
	}
    .prompt {
        position: relative;
        background: #FFE66F;
        padding-left: 40px;
        height: 35px;
        line-height: 35px;
    }
    .prompt_pos {
        position: absolute;
        top:1px;
        right:15px;
    }
</style>
<template>
    <div>
        <!-- 温馨提示 -->
        <div v-if="isShow" class="prompt">
        	<p class="f12 fcred"><i class="fcorg el-icon-warning"></i><span class="bold">&nbsp;温馨提示:</span>当查询的数据量大时，系统查询可能需要较长的时间，请耐心等待并刷新。</p>
        	<span class="finger prompt_pos" @click="hiden">&times;</span>
        </div>
        <!-- context start-->
        <div class="ly-bill p10">
        	<!-- 头部按钮部分 start -->
	        <div class="el-row ly-bill-title">
	            <el-col class="tl">
	                <el-button type="primary" @click="queryData" size="small">
                        <i class="fa fa-refresh"></i>&nbsp;&nbsp;刷&nbsp;新
                    </el-button>
	            </el-col>
	        </div>
	        <!-- 头部按钮部分 end -->
	        <!-- 数据列表部分 start -->
	         <el-table
	         	:data="tableData"
			    stripe
			    style="width: 100%">
			    <el-table-column
			      label="操作"
			      width="180">
			      <template slot-scope="scope">
                    <el-button  type="success" size="small" disabled v-if="tableData[scope.$index].status === 1 || tableData[scope.$index].status === 3">下&nbsp;载</el-button>
			        <el-button  type="success" @click="downloadData(scope.$index,tableData)" size="small" v-else>下&nbsp;载</el-button>
                    <el-button type="info" size="small" disabled v-if="tableData[scope.$index].status === 1 || tableData[scope.$index].status === 3">打&nbsp;开</el-button>
			        <!-- <el-button type="info" @click="openCsv(scope.$index,tableData)" size="small" v-else>打&nbsp;开</el-button> -->
                    <a class="el-button el-button--info el-button--small" target="_blank" :href="'/manage/display-csv.html?path='+encodeURIComponent(tableData[scope.$index].path)+'&source='+encodeURIComponent(tableData[scope.$index].source)" v-else><span>打&nbsp;开</span></a>
			      </template>
			    </el-table-column>
			    <el-table-column
			      prop="status"
			      label="生成状态"
			      width="120">
                  <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.status === 1"
                      type="warning"
                      close-transition>生成中...</el-tag>
                    <el-tag
                      v-if="scope.row.status === 2"
                      type="success"
                      close-transition>已完成</el-tag>
                    <el-tag
                      v-if="scope.row.status === 3"
                      type="danger"
                      close-transition>生成失败</el-tag>
                  </template>
			    </el-table-column>
			    <el-table-column
			      prop="source"
			      label="查询项目">
			    </el-table-column>
			    <el-table-column
			      prop="time"
			      label="查询日期"
                  width="200">
			    </el-table-column>
			    <el-table-column
			      prop="clerk_name"
			      label="查询人"
                  width="100">
			    </el-table-column>
			  </el-table>
	        <!-- 数据列表部分 end -->
	        <!-- 分页 start -->
	        <div class="ly-bill-page">
	            <el-pagination
	                @size-change="handleSizeChange"
	                @current-change="handleCurrentChange"
	                :current-page="submitForm.page"
	                :page-sizes="[10, 20, 30, 40, 50]"
	                :page-size="submitForm.size"
	                layout="total, sizes, prev, pager, next, jumper"
	                :total="totalPage">
	            </el-pagination>
	        </div>
	        <!-- 分页 end -->
        </div>
        <!-- context end -->
    </div>
</template>
<script>
    /**
    * 查询下载中心
    * author by wxq 
    * @time 2017.9.14
    */
	import {mapGetters} from 'vuex'
	export default {
		computed: {
            ...mapGetters('route', [
                'currRoute'
            ])
        },
        data () {
        	return {
        		// 假数据
        		tableData: [],
        		isShow: true,// 提示是否显示
        		// 查询提交时的表单数据
	            submitForm: {
	                page: 1, // 当前分页
	                size: 20 // 每页的条数
	            },
	            totalPage: 0, // 总条数
        	}
        },
        methods: {
        	/**
        	* 隐藏掉提示
        	*/
        	hiden () {
        		this.isShow = false
        	},
        	/**
        	* 刷新获取新的数据
        	*/
        	queryData () {
        		this.$api.download.query(this.submitForm).then((rs) => {
                    this.totalPage = rs.total // 总条数
                    this.tableData = rs.data // 列表数据
                }).catch((msg) => {
                    this.$message(msg)
                })
        	},
        	/**
        	* 下载
        	* {index} 数据索引
        	* {data} 数据
        	*/
        	downloadData (index,data) {
                this.$message({
                    message: '开始下载，请注意下载进度！',
                    type: 'success'
                })
        		if (typeof window.download_file === 'undefined') {
					window.download_file = {}
				}
				if (typeof (window.download_file.iframe) === "undefined") { 
					var iframe = document.createElement("iframe") 
                    iframe.id = "downloadFrame"
					window.download_file.iframe = iframe 
					document.body.appendChild(window.download_file.iframe)
                    var inter = null
                    var self = this
                    iframe.onload = function () {
                        var frameWindow = document.getElementById('downloadFrame').contentWindow
                        if (frameWindow) {
                            var count = 0
                            var frameDocument = frameWindow.document
                            inter = setInterval(function () {
                                if (count === 30) {
                                    clearInterval(inter)
                                }
                                var pres = frameDocument.getElementsByTagName('pre')
                                if (pres.length > 0) {
                                    var text = pres[0].innerText
                                    if (text.length > 0) {
                                        var msgObj = JSON.parse(text)
                                        if (msgObj.status === 500) {
                                            self.$message(msgObj.msg)
                                            clearInterval(inter)
                                        }
                                    }
                                } 
                                count++ 
                            }, 100)
                        }
                    }
				} 			
				window.download_file.iframe.src = "http://" + window.location.host + data[index].path
				window.download_file.iframe.style.display = "none"
        	},
        	/**
        	* 打开
        	*/
        	openCsv (index,data) {
        		// console.log("数据显示===>", index, data)
        	},
        	/**
             * 每页条数选择监听
             */
            handleSizeChange (val) {
                this.submitForm.page = 1
                this.submitForm.size = val
                this.queryData()
            },
            /**
             * 分页监听
             */
            handleCurrentChange (val) {
                this.submitForm.page = val
                this.queryData()
            }
        },
       	mounted () {
       		this.queryData();
		}
	}
</script>